import { cva } from 'class-variance-authority';

export const borderIconVariants = cva('flex rounded-full  justify-center items-center rounded-[14px]', {
  variants: {
    variant: {
      default: 'bg-[#D8BBFF1A] color-[#D8BBFF66] rounded-full',
      success: 'bg-[#FFFFFF1A] text-[#ffffff]',
      glass: 'bg-white/10 backdrop-blur-[25px] rounded-full size-[56px]',
    },
    size: {
      default: 'size-14',
      large: 'size-16',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'default',
  },
});
